import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Stack } from "@mui/material";
import {
  AssignmentInd as AssignmentIndIcon,
  PlayCircle as PlayCircleIcon,
  CheckCircle as CheckCircleIcon,
  TaskAlt as TaskAltIcon,
  Cancel as CancelIcon,
  Replay as ReplayIcon,
  DoneAll as DoneAllIcon,
} from "@mui/icons-material";
import {
  addOrderNote,
  changeOrderStatus,
  mergeOrderUpdate,
  updateOrder,
} from "../features/ordersSlice";
import { orderFlow } from "../utils/orderStatusFlow";
import AssignProviderModal from "./AssignProviderModal";
import { useNavigate } from "react-router-dom";
import NoteModal from "./NoteModal";

export default function OrderActionButton({ order, onAction }) {
  const [localOrder, setLocalOrder] = useState(order);
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  const [openNoteModal, setOpenNoteModal] = useState(false);
  const [pendingStatus, setPendingStatus] = useState(null);

  const currentStatus = localOrder.status;
  // const currentStatus = order.status;
  const nextStatuses = orderFlow[currentStatus] || [];

  const labelMap = {
    pending_dispatch: "استلام الطلب",
    claimed: "تعيين مزود",
    assigned: "تعيين مزود",
    pending_user_payment: "تأكيد الدفع من العميل",
    scheduled: "جدولة",
    in_progress: "بدء التنفيذ",
    completed: "مكتمل",
    provider_payment_confirmation_pending: "تأكيد دفع المزود",
    awaiting_review: "بانتظار مراجعة العميل",
    closed: "مغلق",
    cancelled: "الغاء",
    failed: "فشل",
    refunded: "مسترجع",
  };

  const iconMap = {
    pending_dispatch: <AssignmentIndIcon />,
    claimed: <AssignmentIndIcon />,
    assigned: <PlayCircleIcon />,
    scheduled: <PlayCircleIcon />,
    in_progress: <CheckCircleIcon />,
    completed: <TaskAltIcon />,
    awaiting_review: <TaskAltIcon />,
    closed: <CheckCircleIcon />,
    cancelled: <CancelIcon />,
    failed: <CancelIcon />,
    refunded: <ReplayIcon />,
  };

  // const handleClaimOrder = () => {
  //   const updated = { dispatcher: user.id, status: "claimed" };
  //   dispatch(updateOrder({ orderId: localOrder.id, updates: updated }));
  //   setLocalOrder((prev) => ({ ...prev, ...updated }));
  // navigate("/orders");
  // };

  const handleClaimOrder = () => {
    const updated = { dispatcher: user.id, status: "claimed" };
    dispatch(updateOrder({ orderId: order.id, updates: updated }));
    setLocalOrder((prev) => ({ ...prev, ...updated }));
    navigate("/orders");
  };

  // const handleAdvanceStatus = (nextStatus) => {
  //   // If the action requires a note first
  //   if (["cancelled", "failed", "refunded"].includes(nextStatus)) {
  //     setPendingStatus(nextStatus); // store status temporarily
  //     setOpenNoteModal(true);
  //     return;
  //   }

  //   if (nextStatus === "assigned") {
  //     setOpenModal(true);
  //     return;
  //   }

  //   const updated = { status: nextStatus };
  //   // dispatch(updateOrder({ orderId: localOrder.id, updates: updated }));
  // setLocalOrder((prev) => ({ ...prev, ...updated }));
  //   if (onAction) onAction(localOrder, updated);
  // };

  const handleAdvanceStatus = (nextStatus) => {
    if (["cancelled", "failed", "refunded"].includes(nextStatus)) {
      setPendingStatus(nextStatus);
      setOpenNoteModal(true);
      return;
    }

    if (nextStatus === "assigned") {
      setOpenModal(true);
      return;
    }

    const updated = { status: nextStatus };

    dispatch(mergeOrderUpdate({ ...order, ...updated }));
    dispatch(changeOrderStatus({ orderId: order.id, updates: updated }));
    setLocalOrder((prev) => ({ ...prev, ...updated }));

    // if (onAction) onAction(order, updated);
  };

  // const handleAdvanceStatus = (nextStatus) => {
  //   if (nextStatus === "assigned") {
  //     setOpenModal(true);
  //     return;
  //   }

  //   const updated = { status: nextStatus };
  //   dispatch(updateOrder({ orderId: localOrder.id, updates: updated }));
  //   setLocalOrder((prev) => ({ ...prev, ...updated }));
  //   if (onAction) onAction(localOrder, updated);
  // };

  // const handleSaveNote = async (note) => {
  //   await dispatch(
  //     addOrderNote({
  //       orderId: localOrder.id,
  //       note,
  //       from: user.name,
  //     })
  //   );

  //   const updated = { status: pendingStatus };
  //   await dispatch(updateOrder({ orderId: localOrder.id, updates: updated }));
  // setLocalOrder((prev) => ({ ...prev, ...updated }));

  //   setOpenNoteModal(false);
  //   setPendingStatus(null);

  //   if (onAction) onAction(localOrder, updated);
  // };

  const handleSaveNote = async (note) => {
    await dispatch(
      addOrderNote({
        orderId: order.id,
        note,
        from: user.name,
      })
    );

    const updated = { status: pendingStatus };
    setLocalOrder((prev) => ({ ...prev, ...updated }));

    if (onAction) onAction(order, updated);

    setOpenNoteModal(false);
    setPendingStatus(null);
  };

  const isFinal = ["cancelled", "failed", "refunded"].includes(currentStatus);

  return (
    <>
      {!order.dispatcher ? (
        <Button
          variant="contained"
          color="primary"
          startIcon={<DoneAllIcon />}
          onClick={handleClaimOrder}
        >
          استلام الطلب
        </Button>
      ) : (
        <Stack direction="row" spacing={1}>
          {nextStatuses.map((status) => (
            <Button
              key={status}
              variant="contained"
              color={
                status === "cancelled" || status === "failed"
                  ? "error"
                  : "primary"
              }
              startIcon={iconMap[status] || <TaskAltIcon />}
              onClick={() => handleAdvanceStatus(status)}
              disabled={isFinal}
            >
              {labelMap[status]}
            </Button>
          ))}
        </Stack>
      )}

      {/* Assign provider modal */}
      {openModal && (
        <AssignProviderModal
          order={order}
          open={openModal}
          onClose={() => setOpenModal(false)}
          onSelectProvider={(provider) => {
            const updated = { provider, status: "assigned" };

            console.log("updated provider");
            console.log(provider);

            // dispatch(mergeOrderUpdate({ ...order, ...updated }));
            dispatch(
              updateOrder({
                orderId: order.id,
                updates: { provider: provider.id, status: "assigned" },
              })
            );
            setLocalOrder((prev) => ({ ...prev, ...updated }));

            // dispatch(updateOrder({ orderId: order.id, updates: updated }));
            // if (onAction) onAction(order, updated);
            setOpenModal(false);
          }}
        />
      )}

      <NoteModal
        open={openNoteModal}
        onClose={() => setOpenNoteModal(false)}
        onSave={handleSaveNote}
      />
    </>
  );
}
